<template>
	<v-timeline-item small>
		<v-card>
			<v-card-subtitle class="py-2">
				{{ $store.getters.getDecodedJwtEmpresa.nombre }}
				<v-icon small color="primary">mdi-account</v-icon>
				- {{ new Date().toLocaleString() }}
			</v-card-subtitle>
			<div class="px-4 py-1">
				<text-editor
					v-model="message.msg"
					class="pb-2"
					filled
					dense
					hide-details="auto"
					label="Tu mensaje aquí"
				></text-editor>
			</div>
			<div class="pa-4">
				<v-subheader>Adjuntar archivos</v-subheader>
				<DragAndDrop v-model="message.files" />
				<v-chip class="mt-2" small label>{{ message.files.length }} adjuntos</v-chip>
			</div>
		</v-card>
	</v-timeline-item>
</template>

<script>
export default {
	props: {
		value: Object
	},
	components: {
		TextEditor: () => import("@/components/TextEditor.vue"),
		DragAndDrop: () => import("@/components/DragAndDrop.vue"),
	},
	computed: {
		message: {
			get() { return this.value },
			set(v) { this.$emit('input', v) }
		}
	}
}
</script>